<template>
  <div>
    <slot
      v-if="(err || errorBit) && !isProd"
      name="error"
      v-bind:err="err"
      v-bind:vm="vm"
      v-bind:info="info"
    >      
      <div class="md-layout">
        <div class="md-layout-item">
          <md-dialog-confirm
            v-if="this.errorInfo.includes('demogs_unsupported_no_industry')"
            :md-active.sync="errorBit"
            :md-content="
              '<br>The 3-ring demographic profile as a stand alone product is not supported on the new Bizminer web app.' +
                ' This data is now available through our Industry Market Profile.' +
                ' Please follow the link below to create an industry market profile, then use the add 3-ring analysis tool within the demographics section of that profile. <br>'
            "
            md-confirm-text="Create Industry Market Profile"
            md-cancel-text="Close"
            @md-confirm="
              $router.push({
                name: 'NewMarketProfile',
              })
            "
          />
          <md-dialog-confirm
            v-else-if="this.errorInfo === 'no_data_available'"
            :md-active.sync="errorBit"
            md-content="<br>Full Company Profile data is not available for this company. Please selector another or check back in the future for expanded coverage<br>"
          />
          <md-dialog-confirm
            v-else
            :md-active.sync="errorBit"
            :md-content="
              '<br> <strong>An error has occurred and we have been notified.</strong> ' +
                '<br> Error PROD ID:' +
                this.errorId +
                '<br> ' +
                errorInfo +
                'Click the Report button to report additional details'
            "
            md-confirm-text="Report"
            md-cancel-text="Close"
            @md-confirm="callSupportFunction"
          />
        </div>

        <div class="md-layout-item">
          <md-dialog-confirm
            v-if="this.err.toString().includes('email_already_exists')"
            :md-active.sync="mainError"
            :md-content="'<br>This email address already has an account.'"
            md-cancel-text="Close"
          />
          <md-dialog-confirm
            v-else
            :md-active.sync="mainError"
            :md-content="
              '<br> Error ID:' +
                this.errorId +
                '<br> <strong> Error trace: </strong> ' +
                err +
                '<strong> Vue component/instance: </strong>' +
                (vm ? vm.$options.name : '') +
                ' (name property of the component, if provided)' +
                '<br>' +
                '<strong>  Vue specific error information: </strong>' +
                info
            "
            md-confirm-text="Report"
            md-cancel-text="Close"
            @md-confirm="callSupportFunction"
          />
        </div>
      </div>
    </slot>
    <slot
      v-else
      name="error"
      v-bind:err="err"
      v-bind:vm="vm"
      v-bind:info="info"
    >
      <div class="md-layout">
        <div class="md-layout-item">
          <md-dialog-confirm
            v-if="this.errorInfo.includes('demogs_unsupported_no_industry')"
            :md-active.sync="errorBit"
            :md-content="
              '<br>The 3-ring demographic profile as a stand alone product is not supported on the new Bizminer web app.' +
                ' This data is now available through our Industry Market Profile.' +
                ' Please follow the link below to create an industry market profile, then use the add 3-ring analysis tool within the demographics section of that profile. <br>'
            "
            md-confirm-text="Create Industry Market Profile"
            md-cancel-text="Close"
            @md-confirm="
              $router.push({
                name: 'NewMarketProfile',
              })
            "
          />
          <md-dialog-confirm
            v-else-if="this.errorInfo === 'no_data_available'"
            :md-active.sync="errorBit"
            md-content="<br>Full Company Profile data is not available for this company. Please selector another or check back in the future for expanded coverage<br>"
          />
          <md-dialog-confirm
            v-else
            :md-active.sync="errorBit"
            :md-content="
              '<br> <strong>An error has occurred and we have been notified.</strong> ' +
                '<br> Error PROD ID:' +
                this.errorId +
                '<br><br>Click the Report button to report additional details'
            "
            md-confirm-text="Report"
            md-cancel-text="Close"
            @md-confirm="callSupportFunction"
          />
        </div>
        <div class="md-layout-item">
          <md-dialog-confirm
            v-if="this.err.toString().includes('email_already_exists')"
            :md-active.sync="mainError"
            :md-content="'<br>This email address already has an account.'"
            md-cancel-text="Close"
          />

          <!-- <md-dialog-confirm v-else :md-active.sync="mainError" :md-content="
            '<br> <strong>An error has occurred and we have been notified.</strong> ' +
            '<br> Error ID:' +
            this.errorId +
            '<br><br>Click the Report button to report additional details'
          " md-confirm-text="Report" md-cancel-text="Close" @md-confirm="callSupportFunction" />-->
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "error-handler",
  data() {
    return {
      err: false,
      isProd: false,
      vm: null,
      info: null,
      error: false,
      errorId: null,
      exclusions: [
        "TypeError: Cannot read properties of undefined (reading 'badInput')",
      ],
    };
  },
  async errorCaptured(err, vm, info) {
    // Check for exclusions
    let excluded = false;
    let errStr = err.toString();

    await this.exclusions.forEach((exc) => {
      if (errStr.includes(exc)) {
        excluded = true;
      }
    });
    if (excluded) return false;

    this.err = err;
    this.vm = vm;
    this.info = info;
    this.error = true;
    this.submitError();
    return process.env.VUE_APP_DEV_MODE ? true : false;
  },

  mounted() {
    if (window.location.hostname == "app.bizminer.com") this.isProd = false; // TODO: change this back.
    if (window.origin == "https://library.bizminer.com") { this.isProd = true; } // This actually disables the error display. TODO: adjust this to be correct.
  },
  computed: {
    ...mapGetters({ getErrorBit: "errorBit" }),
    errorBit: {
      get() {
        return this.getErrorBit;
      },
      set(newValue) {
        return this.$store.commit("SET_ERROR_BIT", newValue);
      },
    },
    errorInfo() {
      return this.$store.getters.errorInfo;
    },
    mainError: {
      get() {
        return this.error && !this.errorBit;
      },
      set(newValue) {
        return (this.error = newValue);
      },
    },
  },
  watch: {
    errorInfo() {
      this.submitError();
    },
  },
  methods: {
    callSupportFunction() {
      window.open("https://support.bizminer.com/category/19-technical-issues");
    },
    submitError() {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      let endpointUrl = null;
      let splitError = [];
      if (this.errorInfo) {
        if (this.errorInfo.includes("LINK")) {
          let apiAux = this.errorInfo.substring(
            this.errorInfo.indexOf("K:") + 3
          );

          endpointUrl = apiAux.substring(0, apiAux.indexOf("<"));
        }
        splitError = this.errorInfo.split("<br>");
      }
      let params = {
        session_id: currentSession,
        backend: this.errorBit ? 1 : 0,
        url: window.location.href,
        extra: this.errorBit ? splitError[splitError.length-1] : "Specific error: " + this.info,
        endpoint_url: endpointUrl,
        trace: this.err.toString(),
        file: this.vm ? this.vm.$options.name : "",
        line: "",
      };
      axios
        .post(
          process.env.VUE_APP_API_BASE_URL + "/user/feedback/error",
          {},
          {
            params: params,
          }
        )
        .then((res) => {
          this.errorId = res.data.error_id;

          if (
            
            params.trace.includes("not_logged_in") ||
            params.extra.includes("profile_wrong_user") ||
            params.extra.includes("report_wrong_user")
          )
            this.$router.push({ name: "Login" });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
